<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
  <g id="그룹_21580" data-name="그룹 21580" transform="translate(-472 -774)">
    <circle id="타원_1519" data-name="타원 1519" cx="20" cy="20" r="20" transform="translate(472 774)" fill="#002c5f"/>
    <g id="그룹_19194" data-name="그룹 19194" transform="translate(-1017 395)">
      <rect id="사각형_5703" data-name="사각형 5703" width="20" height="20" transform="translate(1499 389)" fill="#fff" opacity="0"/>
      <g id="그룹_19195" data-name="그룹 19195" transform="translate(1499.786 389.989)">
        <rect id="사각형_5712" data-name="사각형 5712" width="8.374" height="6.687" rx="2" transform="matrix(0.719, -0.695, 0.695, 0.719, -0.695, 13.932)" fill="none" stroke="#fff" stroke-linejoin="round" stroke-width="2"/>
        <rect id="사각형_5713" data-name="사각형 5713" width="8.374" height="6.687" rx="2" transform="matrix(0.719, -0.695, 0.695, 0.719, 8.454, 5.097)" fill="none" stroke="#fff" stroke-linejoin="round" stroke-width="2"/>
        <line id="선_872" data-name="선 872" y1="6.381" x2="6.496" transform="translate(5.842 5.886)" fill="none" stroke="#fff" stroke-linecap="round" stroke-width="2"/>
      </g>
    </g>
  </g>
</svg>
</template>

<script>
export default {

}
</script>

<style>

</style>